import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { viewChecklist } from '../../new-rep-application-interfaces/checklist.interface';
import { viewAttachements } from '../../new-rep-application-interfaces/attachements.interface';
import { MatDialog } from '@angular/material/dialog';
import { NewRepApplicationService } from '../../new-rep-application-services/new-rep-application.service';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';
import { SnackbarService } from '../../../../../shared/services/snackbar/snackbar.service';
import { HttpStatusCode } from 'axios';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { MnchecklistService } from '../../new-rep-application-services/mnchecklist/mnchecklist-service';
import { Router } from '@angular/router';
import { MnchecklistModel } from '../../new-rep-application-models/mnchecklist-models/mnchecklist-model';
import { noWhitespace } from '../../../../../shared/validators/no-whitespace.validator';

@Component({
  selector: 'app-general-information',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatIcon,
    MatButtonModule
  ],
  templateUrl: './general-information.component.html',
  styleUrl: './general-information.component.scss'
})
export class GeneralInformationComponent implements OnInit {


  @Input() formGroup!: FormGroup;
  @Input() generalInformation!: viewChecklist[];
  @Input() viewattachments!: viewAttachements[];
  @Input() readonly = signal(false);
  @Output() next = new EventEmitter<string[]>();
  @Output() preview = new EventEmitter<string[]>();
  @Output() save = new EventEmitter<string>();
  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  private newRepApplicationService = inject(NewRepApplicationService);
  private mnchecklistservice = inject(MnchecklistService);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private router = inject(Router);
  readonly message = 'This field is required.';
  status = 'Not Started';
  attachementRequired = signal(false);
  data = history.state;
  setSprinner = signal(false);

  role = '';
  isVisible = signal(false);

  constructor() { }

  async ngOnInit(): Promise<void> {

    this.formGroup.addControl('generalInformation_1', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('generalInformationyes_1', this.fb.control(''));
    this.formGroup.addControl('generalInformationno_1', this.fb.control(''));
    this.formGroup.addControl('generalInformationno_1_others', this.fb.control(''));
    this.formGroup.addControl('generalInformation_2', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('generalInformationyes_2', this.fb.control(''));
    this.formGroup.addControl('generalInformationyestext_2', this.fb.control(''));
    this.formGroup.addControl('generalInformation_3', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('generalInformationyestext_3', this.fb.control(''));
    this.formGroup.addControl('generalInformationyes_3', this.fb.control(''));
    this.formGroup.addControl('generalInformation_4', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('generalInformation_5', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('generalInformationyes_5', this.fb.control(''));
    this.formGroup.addControl('generalInformationyes_5file', this.fb.control([null]));
    this.formGroup.addControl('generalInformation_6', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('generalInformationyes_6', this.fb.control(''));
    this.formGroup.addControl('generalInformation_7', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('generalInformationyes_7', this.fb.control(''));
    this.formGroup.addControl('generalInformationyes_7file', this.fb.control([null]));
    this.formGroup.addControl('generalInformation_8', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('generalInformation_9', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('connectedpersonname', this.fb.control(''));
    this.formGroup.addControl('relationship', this.fb.control(''));
    this.formGroup.addControl('generalInformation_10', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('generalInformation_11', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('generalInformation_12', this.fb.control('', [Validators.required]));
    this.formGroup.addControl('generalInformation_13', this.fb.control('', [Validators.required]));


    this.role = this.sessionStorageService.getCurrentUserRole();
    if ((this.role === 'DSU' || this.role === 'DSU Manager') && !this.generalInformation) {
      this.isVisible.set(true);
      this.getgeneralInformation();
    } else {
      await this.fetchGeneralInformation();
    }
    this.handleFormStatus();
  }

  fetchGeneralInformation(): void {
    this.formGroup.controls['generalInformation_1']?.setValue(this.generalInformation[0]?.isCompleted);
    this.formGroup.controls['generalInformation_2']?.setValue(this.generalInformation[1]?.isCompleted);
    this.formGroup.controls['generalInformation_3']?.setValue(this.generalInformation[2]?.isCompleted);
    this.formGroup.controls['generalInformation_4']?.setValue(this.generalInformation[3]?.isCompleted);
    this.formGroup.controls['generalInformation_5']?.setValue(this.generalInformation[4]?.isCompleted);
    this.formGroup.controls['generalInformation_6']?.setValue(this.generalInformation[5]?.isCompleted);
    this.formGroup.controls['generalInformation_7']?.setValue(this.generalInformation[6]?.isCompleted);
    this.formGroup.controls['generalInformation_8']?.setValue(this.generalInformation[7]?.isCompleted);
    this.formGroup.controls['generalInformation_9']?.setValue(this.generalInformation[8]?.isCompleted);
    this.formGroup.controls['generalInformation_10']?.setValue(this.generalInformation[9]?.isCompleted);
    this.formGroup.controls['generalInformation_11']?.setValue(this.generalInformation[10]?.isCompleted);
    this.formGroup.controls['generalInformation_12']?.setValue(this.generalInformation[11]?.isCompleted);
    this.formGroup.controls['generalInformation_13']?.setValue(this.generalInformation[12]?.isCompleted);
    if (this.generalInformation[0]?.isCompleted == true) {
      this.formGroup.get('generalInformationyes_1')?.setValidators([Validators.required, noWhitespace]);
      this.formGroup.controls['generalInformationyes_1']?.setValue(this.generalInformation[0]?.responseValue);
      this.formGroup.get('generalInformationyes_1')?.markAsTouched();
    } else {
      if (this.generalInformation[0]?.responseValue[0] === 'Others') {
        this.formGroup.controls['generalInformationno_1']?.setValue(this.generalInformation[0]?.responseValue[0]);
        this.formGroup.get('generalInformationno_1_others')?.setValidators([Validators.required, noWhitespace]);
        this.formGroup.controls['generalInformationno_1_others']?.setValue(this.generalInformation[0]?.responseValue[1]);
      } else {
        this.formGroup.controls['generalInformationno_1']?.setValue(this.generalInformation[0]?.responseValue);
      }
      this.formGroup.get('generalInformationno_1')?.markAsTouched();
    }

    if (this.generalInformation[1]?.isCompleted == true) {
      let value = this.generalInformation[1]?.responseValue.split(',');
      let boolValue = (value[1] === 'true');
      this.formGroup.get('generalInformationyestext_2')?.setValidators([Validators.required, noWhitespace]);
      this.formGroup.controls['generalInformationyestext_2']?.setValue(value[0]);
      this.formGroup.controls['generalInformationyes_2']?.setValue(boolValue);
      this.formGroup.get('generalInformationyestext_2')?.markAsTouched();
    }

    if (this.generalInformation[2]?.isCompleted == true) {
      let value = this.generalInformation[2]?.responseValue.split(',');
      let boolValue = (value[1] === 'true');
      this.formGroup.get('generalInformationyestext_3')?.setValidators([Validators.required, noWhitespace]);
      this.formGroup.controls['generalInformationyestext_3']?.setValue(value[0]);
      this.formGroup.controls['generalInformationyes_3']?.setValue(boolValue);
      this.formGroup.get('generalInformationyestext_3')?.markAsTouched();
    }

    if (this.generalInformation[5]?.isCompleted == true) {
      this.formGroup.get('generalInformationyes_6')?.setValidators([Validators.required, noWhitespace]);
      this.formGroup.controls['generalInformationyes_6']?.setValue(this.generalInformation[5]?.responseValue);
    }

    if (this.generalInformation[8]?.isCompleted == true) {
      let value = this.generalInformation[8]?.responseValue.split(',');
      this.formGroup.get('connectedpersonname')?.setValidators([Validators.required, noWhitespace]);
      this.formGroup.get('relationship')?.setValidators([Validators.required, noWhitespace]);
      this.formGroup.controls['connectedpersonname']?.setValue(value[0]);
      this.formGroup.controls['relationship']?.setValue(value[1]);
    }

    this.viewattachments.forEach(item => {
      if (item?.onboardingDocumentType === 'generalInformation_5') {
        this.formGroup.controls['generalInformationyes_5']?.setValue(item?.fileName);
      } else if (item?.onboardingDocumentType === 'generalInformation_7') {
        this.formGroup.controls['generalInformationyes_7']?.setValue(item?.fileName);
      }
    })

    this.formGroup.updateValueAndValidity();
    if (this.formGroup.valid) {
      const isInProgress =
        (this.formGroup.get('generalInformation_5')?.value &&
          !this.formGroup.get('generalInformationyes_5')?.value) ||
        (this.formGroup.get('generalInformation_7')?.value &&
          !this.formGroup.get('generalInformationyes_7')?.value);

      this.status = isInProgress ? 'In Progress' : 'Completed';
      this.next.emit([this.status, 'submitted']);
    } else if (this.formGroup.invalid) {
      const anyFilled = Object.values(this.formGroup.value).some(v => v && v.toString().trim() !== '');
      if (anyFilled) {
        this.status = 'In Progress';
        this.next.emit([this.status, 'submitted']);
      } else {
        this.status = 'Not Started';
        this.next.emit([this.status, 'submitted']);
      }
    }
    if (this.readonly() == true) {
      this.formGroup?.disable();

    } else {
      this.formGroup?.enable();
    }
  }

  handleFormStatus() {
    // Nothing in a read-only section can be a user edit - the form is disabled.
    // Every emission here is programmatic: the saved data being loaded, and
    // disable() itself, which empties formGroup.value so it can never match the
    // baseline below. Each one overwrote the status the section had just derived
    // from that data, leaving a completed application reading "In Progress".
    if (this.readonly()) return;

    const initialValue = this.formGroup.getRawValue();
    this.formGroup.valueChanges.subscribe(currentValue => {
      const hasChanged =
        JSON.stringify(initialValue) !== JSON.stringify(currentValue);
      if (hasChanged) {
        this.status = 'In Progress';
        this.next.emit([this.status, 'change']);
      }
    });
  }

  onCheckboxChange(checked: boolean, value: any, field: any) {
    if (checked) {
      this.formGroup.get(field)?.setValue(value);
      this.formGroup.get(field)?.markAsUntouched();
    } else {
      this.formGroup.get(field)?.setValue(null);
      this.formGroup.get(field)?.markAsTouched();
    }
  }

  onCheckboxChange1(checked: boolean, value: any, field: any, index: number) {
    if (checked) {
      this.formGroup.get(field)?.setValue(value);
      this.formGroup.get(field)?.markAsUntouched();
      if (this.formGroup.get(field)?.value == true) {
        if (index == 1 || index == 5 || index == 6 || index == 7) {
          this.formGroup.get('generalInformationyes_' + index)?.setValidators([Validators.required, noWhitespace]);
          this.formGroup.get('generalInformationno_' + index)?.clearValidators();
          this.formGroup.get('generalInformationno_' + index)?.reset();
          this.formGroup.get('generalInformationno_1_others')?.clearValidators();
          this.formGroup.get('generalInformationno_1_others')?.reset();
        } else if (index == 9) {
          this.formGroup.get('connectedpersonname')?.setValidators([Validators.required, noWhitespace]);
          this.formGroup.get('relationship')?.setValidators([Validators.required, noWhitespace]);
        } else if (index == 2 || index == 3) {
          this.formGroup.get('generalInformationyestext_' + index)?.setValidators([Validators.required, noWhitespace]);

        }
      } else if (this.formGroup.get(field)?.value == false) {
        if (index == 1) {
          this.formGroup.get('generalInformationno_' + index)?.setValidators([Validators.required]);
          this.formGroup.get('generalInformationno_' + index)?.markAsTouched(); 
          this.formGroup.get('generalInformationno_1_others')?.setValidators([Validators.required]);
          this.formGroup.get('generalInformationyes_' + index)?.clearValidators();
          this.formGroup.get('generalInformationyes_' + index)?.reset();
          if (this.formGroup.get('generalInformationno_' + index)?.value == 'Others') {
            this.formGroup.get('generalInformationno_1_others')?.setValidators([Validators.required, noWhitespace]);
          } else {
            this.formGroup.get('generalInformationno_1_others')?.clearValidators();
            this.formGroup.get('generalInformationno_1_others')?.reset();
          }
          this.formGroup.get('generalInformationno_1')?.updateValueAndValidity();
        } else {
          this.formGroup.get('generalInformationyes_' + index)?.clearValidators();
          this.formGroup.get('generalInformationyes_' + index)?.reset();
          this.formGroup.get('generalInformationyestext_' + index)?.clearValidators();
          this.formGroup.get('generalInformationyestext_' + index)?.reset();
          if (index == 9) {
            this.formGroup.get('connectedpersonname')?.clearValidators();
            this.formGroup.get('relationship')?.clearValidators();
            this.formGroup.get('connectedpersonname')?.reset();
            this.formGroup.get('relationship')?.reset();
          }
        }
      }
    } else {
      this.formGroup.get(field)?.setValue(null);
      this.formGroup.get(field)?.markAsTouched();
    }
  }

  onAttachmentFileChange(event: any, controlName: string, fileVar: string, categoryname: string): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    const control = this.formGroup.get(controlName);

    // ✅ Valid file → update form properly
    this.formGroup.patchValue({
      [fileVar]: file,
      [controlName]: file?.name
    });

    if (!control) return;

    // Reset first
    control.markAsTouched();
    control.setErrors(null);

    if (!file) {
      control.setValue(null);
      return;
    }

    const allowedTypes = new Set([
      'application/pdf',
      'image/jpeg',
      'image/png'
    ]);

    const maxSize = 5 * 1024 * 1024; // 5MB

    // Validate type
    if (!allowedTypes.has(file.type)) {
      control.setErrors({ invalidType: true });
      return;
    }

    // Validate size
    if (file.size > maxSize) {
      control.setErrors({ maxSize: true });
      return;
    }

    control.updateValueAndValidity();
    this.uploaddocument(fileVar, controlName, categoryname)
  }

  async uploaddocument(fileVar: string, controlName: string, categoryname: string) {

    const formData = new FormData();
    formData.append('file', this.formGroup.get(fileVar)?.value);
    formData.append('Description', categoryname);
    formData.append('filename', this.formGroup.get(fileVar)?.value?.name);
    formData.append('ResponseValue', '');
    if (this.role === 'DSU' || this.role === 'DSU Manager') {
      formData.append('UserId', String(this.data.applicant.onboardingid));
    }

    const responseData = await this.newRepApplicationService
      .uploadDocuments(formData)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    if (responseData.status === HttpStatusCode.Ok) {
      this.formGroup.patchValue({
        [controlName]: responseData.data.responsedata
      });

      if (this.role === 'DSU' || this.role === 'DSU Manager') {
        await this.viewDsuDocuments();
      } else {
        await this.viewDocumants();
      }

      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
    }
  }

  async viewDocumants() {
    let id = Number(this.sessionStorageService.getCurrentUserId());
    const responseData = await this.newRepApplicationService
      .viewApplicationDetails(id)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.viewattachments = responseData.data.responsedata.attachments;
  }

  async viewDsuDocuments() {
    let repCode = this.data.applicant.repcode;
    const responseData = await this.mnchecklistservice
      .getmnchecklist(repCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.viewattachments = responseData.data.responsedata.documents;
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  removeFile(controlName: string, fileVar: string, categoryname: string) {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });
    // if (this.role === 'DSU' || this.role === 'DSU Manager') {
    //   this.viewDsuDocuments();
    // } else {
    //   this.viewDocumants();
    // }
    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        if (this.viewattachments) {
          let onboardingId;
          let id;
          let docTypeId;
          if (this.role === 'DSU' || this.role === 'DSU Manager') {
            this.viewattachments.forEach(item => {
              if (item?.onboardingDocumentType === categoryname && ['DSU', 'DSU Manager'].includes(item.updatedByRole)) {
                onboardingId = this.data.applicant.onboardingId;
                docTypeId = item.docTypeId;
                id = item.id;
              }
            })
          }
          else {
            this.viewattachments.forEach(item => {
              if (item?.onboardingDocumentType === categoryname) {
                onboardingId = item.onboardingId;
                docTypeId = item.docTypeId;
                id = item.id
              }

            })
          }

          const data = {
            onboardingId: onboardingId,
            docTypeId: docTypeId,
            id: id
          }
          // if (id) {
          //   const responseData = await this.newRepApplicationService
          //     .deletedocument(data)
          //     .then((response) => {
          //       return JSON.parse(response);
          //     })
          //     .catch((error) => {
          //       // console.error(error);
          //       return error;
          //     });
          //   this.formGroup.patchValue({
          //     fileame: responseData.data.filename
          //   });
          // }
          if (id) {
            const responseData = await this.newRepApplicationService
              .deletedocument(data)
              .then((response) => {
                return JSON.parse(response);
              })
              .catch((error) => {
                return error;
              });

            if (responseData.status === HttpStatusCode.Ok) {
              if (this.role === 'DSU' || this.role === 'DSU Manager') {
                await this.viewDsuDocuments();
              } else {
                await this.viewDocumants();
              }
            }
          }
        }
        this.formGroup.get(controlName)?.reset();
        this.formGroup.get(fileVar)?.reset();
        const fileInput = document.getElementById(controlName) as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
        this.formGroup.controls[controlName].markAsTouched();
        this.formGroup.controls[controlName].updateValueAndValidity();
      } else {
        // console.log('User cancelled');
      }
    });

  }

  async downloadForm() {
    let url = '/sample_documents/employer_consent_on_representative_status_vmay26.pdf';
    let filename = 'employer_consent_on_representative_status_vmay26.pdf';
    const data = {
      filepath: url,
      filename: filename,
    }
    await this.newRepApplicationService.downloadForms(data);
  }

  saveAndContinue() {

    // Save API call or form validation here
    if (this.formGroup.valid) {
      this.status = 'Completed';
    }
    this.formGroup.markAllAsTouched();
    this.next.emit([this.status, 'submit']);
  }

  async saveSection() {
    let savegeneralInformation = new MnchecklistModel();
    savegeneralInformation.setpias_rep_code(this.data.applicant.repcode);

    let responsevalue1;
    if (this.formGroup.get('generalInformation_1')?.value === true) {
      responsevalue1 = this.formGroup.get('generalInformationyes_1')?.value;

    } else {
      responsevalue1 = this.formGroup.get('generalInformationno_1')?.value;
      if (responsevalue1 === 'Others') {
        responsevalue1 = this.formGroup.get('generalInformationno_1_others')?.value;
      }
    }

    savegeneralInformation.setmnChecklist([
      {
        id: this.generalInformation[0]?.id,
        question_id: this.generalInformation[0]?.questionId,
        is_completed: this.formGroup.get('generalInformation_1')?.value,
        response_value: responsevalue1,
      },

      {
        id: this.generalInformation[1]?.id,
        question_id: this.generalInformation[1]?.questionId,
        is_completed: this.formGroup.get('generalInformation_2')?.value,
        response_value: [this.formGroup.get('generalInformationyestext_2')?.value, this.formGroup.get('generalInformationyes_2')?.value].toString(),
      },

      {
        id: this.generalInformation[2]?.id,
        question_id: this.generalInformation[2]?.questionId,
        is_completed: this.formGroup.get('generalInformation_3')?.value,
        response_value: [this.formGroup.get('generalInformationyestext_3')?.value, this.formGroup.get('generalInformationyes_3')?.value].toString(),
      },

      {
        id: this.generalInformation[3]?.id,
        question_id: this.generalInformation[3]?.questionId,
        is_completed: this.formGroup.get('generalInformation_4')?.value,
        response_value: '',
      },

      {
        id: this.generalInformation[4]?.id,
        question_id: this.generalInformation[4]?.questionId,
        is_completed: this.formGroup.get('generalInformation_5')?.value,
        response_value: '',
      },

      {
        id: this.generalInformation[5]?.id,
        question_id: this.generalInformation[5]?.questionId,
        is_completed: this.formGroup.get('generalInformation_6')?.value,
        response_value: this.formGroup.get('generalInformationyes_6')?.value,
      },

      {
        id: this.generalInformation[6]?.id,
        question_id: this.generalInformation[6]?.questionId,
        is_completed: this.formGroup.get('generalInformation_7')?.value,
        response_value: '',
      },

      {
        id: this.generalInformation[7]?.id,
        question_id: this.generalInformation[7]?.questionId,
        is_completed: this.formGroup.get('generalInformation_8')?.value,
        response_value: '',
      },

      {
        id: this.generalInformation[8]?.id,
        question_id: this.generalInformation[8]?.questionId,
        is_completed: this.formGroup.get('generalInformation_9')?.value,
        response_value: [this.formGroup.get('connectedpersonname')?.value, this.formGroup.get('relationship')?.value].toString(),
      },

      {
        id: this.generalInformation[9]?.id,
        question_id: this.generalInformation[9]?.questionId,
        is_completed: this.formGroup.get('generalInformation_10')?.value,
        response_value: '',
      },

      {
        id: this.generalInformation[10]?.id,
        question_id: this.generalInformation[10]?.questionId,
        is_completed: this.formGroup.get('generalInformation_11')?.value,
        response_value: '',
      },

      {
        id: this.generalInformation[11]?.id,
        question_id: this.generalInformation[11]?.questionId,
        is_completed: this.formGroup.get('generalInformation_12')?.value,
        response_value: '',
      },

      {
        id: this.generalInformation[12]?.id,
        question_id: this.generalInformation[12]?.questionId,
        is_completed: this.formGroup.get('generalInformation_13')?.value,
        response_value: '',
      },
    ]);

    const responseData = await this.mnchecklistservice
      .postmnchecklist(savegeneralInformation)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.save.emit('saved');
      this.getgeneralInformation();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar(
          'We couldn’t process your request. Please try again',
        );
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar('Session timed out. Try logging in again!');
        this.router.navigate(['/login']);
      }
    };
  }

  cancelSection() {
    this.save.emit("cancelled");
  }

  previewAttachment(controlName: string, categoryName: string) {
    if (this.viewattachments) {
      let id;
      this.viewattachments.forEach(item => {
        if (item?.onboardingDocumentType === categoryName) {
          id = item.id;
        }
      });
      let filename = this.formGroup.get(controlName)?.value;
      this.preview.emit([id, filename]);
    }
  }

  async getgeneralInformation() {
    this.setSprinner.set(true);
    let repCode = this.data.applicant.repcode;

    const responseData = await this.mnchecklistservice
      .getmnchecklist(repCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.generalInformation = responseData.data.responsedata.check_list
        .filter((item: any) => item.categoryName.includes('generalInformation_'))
        .sort((a: any, b: any) => {
          const aIndex = Number(a.categoryName.split('_').pop());
          const bIndex = Number(b.categoryName.split('_').pop());
          return aIndex - bIndex;
        });
      this.viewattachments = responseData.data.responsedata.documents;
      this.fetchGeneralInformation();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar(
          'We couldn’t process your request. Please try again',
        );
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar('Session timed out. Try logging in again!');
        this.router.navigate(['/login']);
      }
    }
  }
}


